export const messages = {
  en: {
    housekeeping: {
      title: 'Housekeeping Services',
      serviceNamePlaceholder: 'Enter service name',
      service: {
        id: 'Service ID',
        name: 'Service Name',
        type: 'Service Type',
        dispatch: 'Dispatch Method',
        dispatchOptions: {
          grab: 'Grab Order',
          assign: 'Assign',
          polling: 'Polling'
        },
        revisit: 'Revisit Method',
        revisitOptions: {
          none: 'No Revisit',
          rated: 'No Revisit After Rating',
          all: 'All Revisit'
        },
        sales: 'Sales',
        fee: 'Default Fee',
        sort: 'Sort',
        status: 'Status',
        statusOptions: {
          offline: 'Offline',
          online: 'Online'
        },
        createTime: 'Create Time',
        operations: 'Operations'
      }
    }
  },
  zh: {
    housekeeping: {
      title: '家政服务',
      serviceNamePlaceholder: '请输入服务名称',
      service: {
        id: '服务编号',
        name: '服务名称',
        type: '服务类型',
        dispatch: '派单方式',
        dispatchOptions: {
          grab: '抢单',
          assign: '指派',
          polling: '轮训'
        },
        revisit: '回访方式',
        revisitOptions: {
          none: '都不回访',
          rated: '已评价不回访',
          all: '都回访'
        },
        sales: '销量',
        fee: '默认费用',
        sort: '排序',
        status: '状态',
        statusOptions: {
          offline: '未上架',
          online: '上架'
        },
        createTime: '创建时间',
        operations: '操作'
      }
    }
  }
}